import { PermissionRepository } from '../../domain/repositories/PermissionRepository'
import { PermissionDatasource } from '../datasource/PermissionDatasource'

export const permissionRepositoryAdapter = (
  permissionDatasource: PermissionDatasource
): PermissionRepository => {
  return {
    async getUserPermissions(personaId) {
      return await permissionDatasource.getUserPermissions(personaId)
    }
  }
}
